import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CUSTOMER_OPEN_CASE = "CUSTOMER_OPEN_CASE";
export const CUSTOMER_OPEN_CASE_LOADING =
"CUSTOMER_OPEN_CASE_LOADING";
export const CUSTOMER_OPEN_CASE_LOADING_FAILED =
"CUSTOMER_OPEN_CASE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const openACaseLoading = ms => ({
    type: CUSTOMER_OPEN_CASE_LOADING,
    payload: ms
    });
    
    export const openACaseLoadingFailed = ms => ({
    type: CUSTOMER_OPEN_CASE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function openACase(obj) {
    const request = axios.post(
    `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/cases/openCase`,obj, {
        headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
      });
    return dispatch => {

    dispatch(openACaseLoading());
    request
    .then(response => {   
  
    if (response.status == 201) {
     console.log(response,"response openACase")
    dispatch({
    type: CUSTOMER_OPEN_CASE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        openACaseLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(openACaseLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(openACaseLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(openACaseLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


